<template>
  <div :id="$style.goods_detail">
    <a @click="openViewer">
      <div :id="$style.img">
        <img :src="item_data.image" alt />
      </div>
    </a>
    <div :id="$style.title">{{ item_data.title }}</div>
    <div :id="$style.price">&yen;{{ item_data.price }}</div>

    <div :class="{[$style.viewer]: true, [$style.active]: flag}" v-show="flag">
      <div :class="$style.contents">
        <button :class="$style.closs" @click="openViewer">
          <div :class="$style.border"></div>
          <div :class="$style.border"></div>
        </button>
        <img :src="item_data.image" alt />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "GoodsDetail",
  data() {
    return {
      flag: false
    };
  },
  props: {
    item_data: {
      type: Object
    }
  },
  methods: {
    openViewer() {
      this.flag = !this.flag;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $font_size: 13px;

  #goods_detail {
    width: 150px;
    padding: 15px 4px;
    text-align: center;
    a {
      display: inline-block;
      cursor: pointer;
      #img {
        width: 140px;
        height: 120px;
        position: relative;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    #title {
      font-size: $font_size;
      margin: 0 2px;
      margin-top: 3px;
      margin-bottom: 4px;
    }
    #price {
      font-size: $font_size;
    }
    // 拡大画像
    .viewer {
      z-index: 999;
      background: rgb(119, 119, 119, 0.7);
      position: fixed;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      .contents {
        opacity: 1;
        margin: auto;
        height: 300px;
        width: 300px;
        // background: #f8f8f8;
        background: #fff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        // バツボタン
        .closs {
          height: 30px;
          width: 30px;
          position: absolute;
          background: transparent;
          top: 10px;
          right: 10px;
          border: none;
          outline: none;
          cursor: pointer;
          .border {
            background-color: #000;
            margin: auto;
            width: 20px;
            height: 1px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
          .border:nth-child(1) {
            transform: rotate(-45deg);
          }
          .border:nth-child(2) {
            transform: rotate(45deg);
          }
        }
        img {
          position: absolute;
          margin: auto;
          max-width: 230px;
          max-height: 230px;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  $font_size: 13px;

  #goods_detail {
    width: 150px;
    margin: 15px 40px;
    text-align: center;
    a {
      display: inline-block;
      cursor: pointer;
      #img {
        width: 150px;
        height: 120px;
        position: relative;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    #title {
      font-size: $font_size;
      margin-top: 3px;
      margin-bottom: 4px;
    }
    #price {
      font-size: $font_size;
    }
    // 拡大画像
    .viewer {
      z-index: 999;
      background: rgb(119, 119, 119, 0.7);
      position: fixed;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      .contents {
        opacity: 1;
        margin: auto;
        height: 500px;
        width: 600px;
        // background: #f8f8f8;
        background: #fff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        // バツボタン
        .closs {
          height: 30px;
          width: 30px;
          position: absolute;
          background: transparent;
          top: 10px;
          right: 10px;
          border: none;
          outline: none;
          cursor: pointer;
          .border {
            background-color: #000;
            margin: auto;
            width: 20px;
            height: 1px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
          .border:nth-child(1) {
            transform: rotate(-45deg);
          }
          .border:nth-child(2) {
            transform: rotate(45deg);
          }
        }
        img {
          position: absolute;
          margin: auto;
          max-width: 400px;
          max-height: 400px;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }
  }
}
</style>
